import { useSelector } from "react-redux"
import { hasPermission } from "helpers/helpers"

const PERMISSION_KEY = "update-affiliate_bonus"

// Fails open: until the backend defines this permission key, every user keeps
// today's (ungated) behavior. Once it's added to the permission catalogue,
// access follows the current user's own role permissions as usual.
export const useCanManageAffiliateBonuses = () => {
  const allPermissions = useSelector(state => state.permissions.Index ?? [])
  const permissionDefined = allPermissions.some(p => p.name === PERMISSION_KEY)
  return permissionDefined ? hasPermission(PERMISSION_KEY) : true
}
